<template>
  <table class="ks-is-fullwidth">
    <template v-if="details.DiscValue !== null || details.DiscPercent !== null">
      <tr>
        <td>
          {{ Catalog.TotalBruto.Label }}
        </td>
        <td class="has-text-right">
         <kst-value class="print-thermal-size" field="TotalBruto" :data="details" :catalog="Catalog"/>
        </td>
      </tr>

      <tr>
        <td class="is-flex">
          <template v-if="details.DiscValue !== null">
            {{ Catalog.DiscValue.PrintLabel }}
          </template>
          <template v-else-if="details.DiscPercent !== null">
            {{ Catalog.DiscPercent.PrintLabel }}
            (<kst-value class="print-thermal-size" field="DiscPercent" :data="details" :catalog="Catalog"/>)
          </template>
        </td>
        <td class="has-text-right">
          <kst-value class="print-thermal-size" field="TotalDisc" :data="details" :catalog="Catalog"/>
        </td>
      </tr>
    </template>

    <tr>
      <td>
        {{ Catalog.Total.Label }}
      </td>
      <td class="has-text-right">
        <kst-value class="print-thermal-size" field="Total" :data="details" :catalog="Catalog"/>
      </td>
    </tr>

    <tr>
      <td>
        {{ Catalog.TotalItems.Label }}
      </td>
      <td class="is-flex is-justify-content-end">
        <kst-value class="print-thermal-size ks-space-right"
          field="TotalItems" :data="details" :catalog="Catalog"
        />
        {{ Catalog.TotalItems.HelpLabel }}
      </td>
    </tr>
  </table>
</template>

<script>
import Catalog from "../RinvCatalog.js";

export default {
  props: {
    details: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>